// Measure the complete sticky header group, including announcement rows.
(() => {
 const header=document.getElementById('header-group');
 if(!header)return;
 const update=()=>document.documentElement.style.setProperty('--product-header-clearance',`${Math.ceil(header.getBoundingClientRect().height)}px`);
 new ResizeObserver(update).observe(header);update();
 window.addEventListener('resize',update,{passive:true});
 const observed=new WeakSet();
 const measureMedia=()=>{
  for(const panel of document.querySelectorAll('.product-information__media')){
   const gallery=panel.querySelector('media-gallery');
   const stage=gallery?.querySelector('slideshow-container');
   if(!gallery || !stage)continue;
   if(!observed.has(gallery)){observed.add(gallery);mediaObserver.observe(gallery);}
   if(matchMedia('(min-width:1024px)').matches){
    const extra=Math.max(0,Math.ceil(gallery.getBoundingClientRect().height-stage.getBoundingClientRect().height));
    if(panel.style.getPropertyValue('--product-media-extra')!==`${extra}px`)panel.style.setProperty('--product-media-extra',`${extra}px`);
   }
  }
 };
 const mediaObserver=new ResizeObserver(measureMedia);
 new MutationObserver(measureMedia).observe(document.querySelector('main') || document.body,{subtree:true,childList:true});
 window.addEventListener('resize',measureMedia,{passive:true});measureMedia();
})();
